import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShuffleIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.56 11.56L18.02 9.16H12.5V7.4H18.04L15.56 4.8L16.64 3.72L21 8.28L16.64 12.64L15.56 11.56ZM11.44 11.88L12.08 13.52C13 15.88 14.32 16.96 16.26 16.96H18.02L15.56 14.56L16.64 13.48L21 17.84L16.64 22.4L15.56 21.32L18.02 18.72H15.96C13.34 18.72 11.62 17.36 10.32 14.24L9.68 12.6C8.76 10.24 7.44 9.16 5.5 9.16H3.74V7.4H5.8C8.42 7.4 10.14 8.76 11.44 11.88ZM3.74 18.82V16.86H9.3V18.82H3.74Z" />
    </SvgIcon>
  );
});
